import React from 'react';

export function WorkspacePage({ children, className = '' }) {
  return <section className={`workspace-page ${className}`.trim()}>{children}</section>;
}

export function PageHeader({ title, description, actions }) {
  return (
    <header className="workspace-page__header">
      <div className="workspace-page__heading">
        <h1>{title}</h1>
        {description && <p>{description}</p>}
      </div>
      {actions && <div className="workspace-page__actions">{actions}</div>}
    </header>
  );
}

export function PageToolbar({ filters, actions }) {
  return (
    <div className="workspace-toolbar">
      {filters && <div className="workspace-toolbar__filters">{filters}</div>}
      {actions && <div className="workspace-toolbar__actions">{actions}</div>}
    </div>
  );
}

export function DataTable({ children, className = '' }) {
  return (
    <div className="workspace-table">
      <div className="table-responsive">
        <table className={`table align-middle ${className}`.trim()}>{children}</table>
      </div>
    </div>
  );
}

export function FormActions({ children }) {
  return <div className="workspace-form-actions">{children}</div>;
}